module.exports = __webpack_public_path__ + "img/bgRight.f4524987.png";